module.exports = __webpack_public_path__ + "img/battle-crackers-play.8a9458e5.jpg";